import React from "react";
import PartnerSection from "../PartnerSection";
import CountUp from "react-countup";
import sIcon1 from "../../images/icons/icon_head.svg";
import sIcon2 from "../../images/icons/icon_check.svg";
import sIcon3 from "../../images/icons/icon_like.svg";
import sIcon4 from "../../images/icons/icon_dart_board.svg";
import Bg from "../../images/shapes/bg_pattern_1.svg";
import video from "../../images/backgrounds/Brand-Promo-1.webm";

const FunFact = [
  {
    title: "8",
    subTitle: "Years of experience",
    symbol: "+",
    icon: sIcon1,
  },
  {
    title: "250",
    subTitle: "Clients",
    symbol: "+",
    icon: sIcon2,
  },
  {
    title: "100",
    subTitle: "Companies Trust Us",
    symbol: "+",
    icon: sIcon3,
  },
  {
    title: "100",
    subTitle: "Results Guaranteed",
    symbol: "%",
    icon: sIcon4,
  },
];

const FeaturesSection = (props) => {
  return (
    <section
      className="client_logo_section section_space"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="container">
        <div className="section_space pt-0">
          <div className="heading_block text-center">
            <div className="heading_focus_text mb-0">
              <span className="badge bg-secondary text-white">Brand We</span>
              Work With
            </div>
          </div>
          <PartnerSection />
        </div>

        <div className="row funfact_wrapper">
          <div className="col-sm-8">
            <div className="row">
              {FunFact.map((funfact, fitem) => (
                <div className="col-sm-6" key={fitem}>
                  <div className="funfact_block">
                    <div className="funfact_icon">
                      <img
                        src={funfact.icon}
                        alt="RashTech Info - SVG Icon Head"
                      />
                    </div>
                    <div className="funfact_content">
                      <div className="counter_value">
                        <span className="odometer" data-count="25">
                          <CountUp end={funfact.title} enableScrollSpy />
                        </span>
                        <span>{funfact.symbol}</span>
                      </div>
                      <h3 className="funfact_title mb-0">{funfact.subTitle}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-4">
            <div className="our_world_employees">
              <div className="image_wrap">
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="hero-video rounded-4"
                >
                  <source src={video} type="video/webm" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
